import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from "@ngrx/data";
import {ProductDeliveredDataService} from "./impl/service/ngrx/productDeliveredData.service";
import {ProductDeliveredService} from "./impl/service/ngrx/productDelivered.service";

@NgModule({
    providers: [
        ProductDeliveredDataService,
        ProductDeliveredService,
    ],
    imports: []
})
export class ProductDeliveredModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: ProductDeliveredService,
                dataService: ProductDeliveredDataService,
    ) {

        entityDataService.registerServices({
            'ProductDelivered': dataService,
        });

        entityServices.registerEntityCollectionServices({
            'ProductDelivered': service,
        });

        // errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
